import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
const formatDateForRequest = 'YYYY-MM-DD HH:mm:ssZ';

function getAutoGranularity(dateRange) {

  const [start, end] = dateRange;

  let granularity;
  const diff = end.diff(start, 'days');

  if (diff >= 7 * 3) granularity = 'weeks';
  else if (diff <= 1) granularity = 'hours';
  else granularity = 'days';

  return granularity;

}

function getDateFormatForRequest(date) {

  return dayjs.utc(date).format(formatDateForRequest);

}

export default { getAutoGranularity, getDateFormatForRequest };
